import React from 'react';
import { Mic, MicOff } from 'lucide-react';

const ParticipantItem = ({ participant, isMe, channel, isMuted, isCallConnected }) => {
  return (
    <div className="glass-panel p-3 rounded-lg border border-white/5">
      <div className="flex items-center gap-3">
        <div
          className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center ${
            isMe
              ? 'bg-gradient-to-br from-blue-500 to-purple-600'
              : 'bg-gradient-to-br from-orange-500 to-red-600'
          }`}>
          <span className="text-sm font-semibold text-white">
            {participant.name.charAt(0).toUpperCase()}
          </span>
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-white font-medium truncate flex items-center gap-2">
            <span>{participant.name} {isMe && '(You)'}</span>
            <span className="text-xs px-1.5 py-0.5 bg-zinc-700 rounded text-zinc-300">
              Ch{channel !== null ? channel : '?'}
            </span>
          </div>
          <div className="text-xs text-zinc-400 flex items-center gap-1.5">
            {isMuted ? (
              <>
                <MicOff className="w-3 h-3 text-red-400"/>
                <span>Muted</span>
              </>
            ) : isCallConnected ? (
              <>
                <Mic className="w-3 h-3 text-green-400"/>
                <span>Unmuted</span>
              </>
            ) : (
              <span>Ready</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParticipantItem;
